import React, { useState } from "react";
import { baseUrl } from "../shared";
import '../pages/App.css';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import Typography from '@mui/material/Typography';

export function Login() {
  
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState ("");
    
    const [showPassword, setShowPassword] = React.useState(false);

    const [errorText, setErrorText] = useState(true);
    const [serverErrorLoginKey, setServerErrorLoginKey] = useState();
    const [serverErrorMessage, setServerErrorMessage] = useState("");
    
    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
    event.preventDefault();}
  
    const login = () => {
      if(password === '' || username === '') {
          setServerErrorLoginKey(`${Math.floor((Math.random() * 1000))}-min`);
          setServerErrorMessage("Enter a Username & Password to login")
          setErrorText(false);
      } else {
    const url = baseUrl+"user/login";
    var payload = {
      "username": username,
      "password": password,
    }
    fetch(url, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',            
        },
        body: ( "json", JSON.stringify( payload ) )
      })
        .then((response) => response.json())
      .then((data) => {
        console.log(data)
        if (data.status === 401) {
          setErrorText(false);
          setServerErrorMessage(data.message);
          setServerErrorLoginKey(`${Math.floor((Math.random() * 1000))}-min`);
        } else {
          console.log("login: ",data);
          localStorage.setItem("token", data.token)
          localStorage.setItem("username", data.result.username)
          localStorage.setItem("bToken", data.bToken)
          localStorage.setItem("name", data.result.name)
        localStorage.setItem("isPayroll", data.result.isPayroll)
        localStorage.setItem("isConsultant", data.result.isConsultant)
        localStorage.setItem("canAdmin", data.result.canAdmin)
        localStorage.setItem("canApproveConsultant", data.result.canApproveConsultant)
        localStorage.setItem("canApprovePayroll", data.result.canApprovePayroll)
        localStorage.setItem("canPayout", data.result.canPayout)
          window.location.href='/'
        }
      }).catch((error) => {
          setErrorText(false);
        setServerErrorMessage(error.message);
        setServerErrorLoginKey(`${Math.floor((Math.random() * 1000))}-min`);
     });;
    }
    };
  
    return (
      <Box sx={{ pt: 1 }}>
            <TextField
                fullWidth
                margin="dense"
                label="Username"
                variant="outlined"
                type="text"
                onChange = { (e) => {
                    setUsername (e.target.value);
                }}
            />
            <FormControl fullWidth margin="dense" variant="outlined">
          <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
          <OutlinedInput
            id="outlined-adornment-password"
            type={showPassword ? 'text' : 'password'}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            onChange = { (e) => {
              setPassword (e.target.value);
          }}
          onKeyDown={(e) => (
            e.keyCode === 13 ? login(e) : null
          )}
            label="Password"
          />
        </FormControl>
        <Box key={serverErrorLoginKey} hidden={errorText} sx={{ mt: 1 }}>
          <Typography sx={{ color: 'var(--fail)', fontSize: 13, fontWeight: 600 }}>{serverErrorMessage}</Typography>
        </Box>
        <Button fullWidth variant="contained" size="large" onClick={login} sx={{ mt: 2 }}>Login</Button>
     </Box>
    );
  }

export default Login